import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCopySharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-copy-sharp-line__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.006 3.992h-1v12.512h12.511V3.991H5.006Zm1 10.512V5.992h8.511v8.512H6.006ZM20.02 9.372v-1h-2v9.636H8.385v2h11.636V9.372Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="icon-copy-sharp-line__a">
        <path fill="currentColor" d="M.013 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconCopySharpLine);
export default Memo;
